import * as PropTypes from 'prop-types';

import ReviewConstants, {ReviewSummary} from 'notebook/reviews/ReviewConstants';

export enum ConfigSavingState {
  NOT_EDITING = 'NOT_EDITING',
  EDITING = 'EDITING',
  SAVING = 'SAVING',
}

export enum ReviewCriterionStatus {
  UNREVIEWED = 'UNREVIEWED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
}
export const REVIEW_CRITERION_STATUS = ReviewCriterionStatus;

/**
 * @deprecated Use ReviewConstants.ReviewSummary directly
 */
export type Review = ReviewSummary;

export const REVIEW_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  status: PropTypes.oneOf(ReviewConstants.ALL_STATUSES).isRequired,
  authors: PropTypes.array.isRequired,
  auditors: PropTypes.array.isRequired,
});

export interface ReviewCriterion {
  id?: string | null;
  text: string;
  status: ReviewCriterionStatus;
}

export interface SavedReviewCriterion extends ReviewCriterion {
  id: string;
}

export const REVIEW_CRITERION_SHAPE = PropTypes.shape({
  id: PropTypes.string,
  text: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    REVIEW_CRITERION_STATUS.UNREVIEWED,
    REVIEW_CRITERION_STATUS.PASSED,
    REVIEW_CRITERION_STATUS.FAILED,
  ]).isRequired,
});

export interface ReviewCriteriaGroup {
  id?: string | null;
  name: string;
  reviewCriteria: Array<ReviewCriterion>;
}

export interface SavedReviewCriteriaGroup {
  id: string;
  name: string;
  reviewCriteria: Array<SavedReviewCriterion>;
}

export const REVIEW_CRITERIA_GROUP_SHAPE = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  reviewCriteria: PropTypes.arrayOf(REVIEW_CRITERION_SHAPE.isRequired).isRequired,
});
